import cx from 'classnames'
import { CalculatorIcon, TrashIcon } from '@/common/components/icons'
import { Button, IconButton } from '@/common'
import useI18n from '@/shared/hooks/useI18n'
import { usePermissions } from '@/shared/hooks/usePermissions'

export default function ProcessEmissionsAssetEmissionCalculateButton({
  emissionType,
  onCalculateClick,
  isViewMode,
  method,
  hasEmissionRecord,
  onRemove
}: {
  hasEmissionRecord: boolean
  emissionType: string
  onCalculateClick: (emissionType: string, method: string) => void
  isViewMode: boolean
  method: string
  onRemove: () => void
}) {
  const { t } = useI18n()
  const { checkPermission } = usePermissions()
  const canEditReport = checkPermission('emissionReport', 'update')

  return (
    <div className="flex items-center justify-end gap-2">
      <Button
        key={method}
        variant="txt-default"
        sizeType="sm"
        disabled={isViewMode || !canEditReport}
        className={cx('flex items-center', { 'w-full': !hasEmissionRecord })}
        onClick={() => onCalculateClick(emissionType, method)}
        icon={<CalculatorIcon />}
      >
        {hasEmissionRecord ? t(`common:actions.edit`) : t(`common:calculationMethods.${method}`)}
      </Button>
      {hasEmissionRecord && (
        <IconButton
          icon={<TrashIcon />}
          variant="txt-danger"
          onClick={onRemove}
          disabled={isViewMode || !canEditReport}
        />
      )}
    </div>
  )
}
